import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';

import Header from '@components/Header';
import NewCountryModal from '@components/Countries/NewCountryModal';
import EditCountryModal from '@components/Countries/EditCountryModal';
import JustificationModal from '@components/JustificationModal';

import { getCoutries, newCountry, editCountry, updateVisibilityStatus, reOrderCountries } from '@actions/countries';
import { setCatalogCurrentCountries } from '@actions/catalogs';
import { validatePermissionAction } from '@actions/sessionPermission';
import { sendActionToBitacora  } from '@actions/bitacora';

import { getValueLanguageObj } from '@utils/general'

import {
  StatusVisible,
  LANGUAGE_DEFAULT
} from '@constants/general'
import catalogPermissionsId from '@constants/catalogPermissionsId';

import './style.scss'

const IS_EDIT = true

class Countries extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: true,
      loadingTable: true,
      business: [],
      showModalCountry: {
        isVisible: false,
        continueAction: null,
      },
      showModalEditCountry: {
        isVisible: false,
        data: {},
        continueAction: null,
      },
      showModalJustification: {
        isVisible: false,
        title: '',
        description: '',
        label: '',
        continueAction: null,
      }
    };
  }

  componentDidMount() {
    this.loadData();
    return this.setState({loadingPage: false})
  }

  loadData = async (isEdit = false) => {
    const { getCoutries } = this.props;
    this.setState({ loadingTable: true });
    const params = {
      type: 'all'
    };

    const response = await getCoutries(params);
    if (!response?.status) {
      if (isEdit) this.setCatalagCountriesUpdate(response.data)
      return this.setState({
        business: response.data,
        loadingTable: false,
      });
    }
    return this.setState({ loadingTable: false });
  };

  setCatalagCountriesUpdate = (data) => {
    const { setCatalogCurrentCountries } = this.props
    const getVisiblesCountries = data.filter(item => item.visible === 1)
    setCatalogCurrentCountries(getVisiblesCountries)
  }


  onChange = ({target}) => {
    console.log('this.onChange', target)
    this.setState({[target.name]: target.value});
  };

  onChangeSearch = (e) => {
    this.setState({
       [e.target.name]: e.value ,
    });
  };

  onConfirmDeleteDocument = (data) => {
    const { t } = this.props;
    this.setState({
      showModalJustification: {
        isVisible: true,
        title: t('CONFIRMACIÓN'),
        description: t('¿Esta seguro que desea eliminar {{ELEMENTO}}?', {ELEMENTO: data.fc_nombre}),
        label: t('Justificación de la eliminación'),
        continueAction: ({justification}) => this.onDeleteCompany(data, justification),
      },
    });
  }

  onDeleteCompany = async (data, justification) => {
    const { t, deleteCompany } = this.props;
    const response = await deleteCompany({id: data.id, justification});
    if (!response?.status) {
      this.toast.show({
        severity: 'success',
        summary: t('Confirmación'),
        detail: t('La operación se ha realizado de manera éxitosa'),
        life: 3000,
      });
    }
    return true;
  };

  onChangeStatusCompany = async (data, justification) => {
    const { t, updateStatus } = this.props;
    const response = await updateStatus({id: data.id, justification});
    if (!response?.status) {
      this.toast.show({
        severity: 'success',
        summary: t('Confirmación'),
        detail: t('La operación se ha realizado de manera éxitosa'),
        life: 3000,
      });
    }
    return true;
  };

  onOpenModalEditCompany = (node) => {
    this.setState({
      showModalEditCountry: {
        isVisible: true,
        data: node,
        continueAction: (data) => this.onEditCountry(data),
      },
    });
  }

  onEditCountry = async (data) => {
    const { t, editCountry, sendActionToBitacora } = this.props
    const response = await editCountry(data)
    if (!response?.status) {
      const dataBitacora = {
        transactionName: 'actPais',
        reason: `${getValueLanguageObj(data.name, LANGUAGE_DEFAULT)} || ${data.justification}`,
      }
      await sendActionToBitacora(dataBitacora)
      await this.loadData(IS_EDIT)
      this.toast.show({
        severity: 'success',
        summary: t('Confirmación'),
        detail: t('La operación se ha realizado de manera éxitosa'),
        life: 3000,
      });
    }
  }


  templateEdit = (node, detail) => (
    <div>
      <span className="p-column-title">{detail.header}</span>
      <Button
        type="button"
        icon="pi pi-pencil"
        className="p-button-text"
        style={{ marginRight: '.5em' }}
        onClick={() => this.onOpenModalEditCompany(node)}
      />
    </div>
  );

  validateCountry = (node) => {
    const { countriesCurrentCatalog } = this.props
    const getCountry = countriesCurrentCatalog.find(item => item.id === node.fc_id_pais)
    return getCountry.label
  }

  visibleCountry = (node, detail) => {
    const { t, validatePermissionAction } = this.props;
    const hasPermissionShowHiddenCountry = validatePermissionAction(catalogPermissionsId.MOSTRAR_OCULTAR_PAISES)
    if (node.visible === StatusVisible.IS_VISIBLE) {
      return (
        <div>
          <span className="p-column-title">{detail.header}</span>
          <Button
            type="button"
            icon="pi pi-check"
            className={`p-button-text ${hasPermissionShowHiddenCountry ? '' : 'cursor-not-pointer'}`}
            style={{ marginRight: '.5em' }}
            onClick={hasPermissionShowHiddenCountry ? () => this.onConfirmVisible(node) : () => {}}
          />
        </div>
      );
    }
    if (node.visible === StatusVisible.IS_HIDDEN) {
      return (
        <>
          <span className="p-column-title">{detail.header}</span>
          <span className={`badge-red cursor-pointer ${hasPermissionShowHiddenCountry ? '' : 'cursor-not-pointer'}`} aria-hidden="true" onClick={hasPermissionShowHiddenCountry ? () => this.onConfirmVisible(node) : () => {}}> {t('OCULTO')} </span>
        </>
      );
    }
    return (<span className="p-column-title">{detail.header}</span>);
  }

  templateClave = (rowData, detail) => (
    <>
        <span className="p-column-title">{detail.header}</span>
        {rowData.clave}
    </>
  );

  onHideModal = () => {
    this.setState({
      showModalCountry: {
        isVisible: false,
      },
    });
  };

  openMoldalNewCountry = () => {
    this.setState({
      showModalCountry: {
        isVisible: true,
        continueAction: (data, justification) => this.createNewCountrie(data, justification),
      },
    });
  }

  createNewCountrie = async (data, justification) => {
    const { t, newCountry, sendActionToBitacora } = this.props
    const response = await newCountry(data)
    if (!response?.status) {
      const dataBitacora = {
        transactionName: 'altaPais',
        reason: `${getValueLanguageObj(data.name, LANGUAGE_DEFAULT)} || ${justification}`,
      }
      await sendActionToBitacora(dataBitacora)
      await this.loadData(IS_EDIT)
      this.toast.show({
        severity: 'success',
        summary: t('Confirmación'),
        detail: t('La operación se ha realizado de manera éxitosa'),
        life: 3000,
      });
    }
  }

  onConfirmVisible = (data) => {
    const { t } = this.props;
    this.setState({
      showModalJustification: {
        isVisible: true,
        title: t('CONFIRMACIÓN'),
        description: t('¿Esta seguro que desea hacer este cambio?'),
        continueAction: ({justification}) => this.onChangeVisibleStatus(data, justification),
      },
    });
  };

  onChangeVisibleStatus = async (data, justification) => {
    const { t, updateVisibilityStatus, sendActionToBitacora } = this.props;
    const response = await updateVisibilityStatus({...data, justification});
    if (!response?.status) {
      const dataBitacora = {
        transactionName: data.visible === StatusVisible.IS_VISIBLE ? 'desacPais' : 'activaPais',
        reason: `${getValueLanguageObj(data.nombre, LANGUAGE_DEFAULT)} || ${justification}`,
      }
      await sendActionToBitacora(dataBitacora)
      await this.loadData(IS_EDIT)
      this.toast.show({
        severity: 'success',
        summary: t('Confirmación'),
        detail: t('La operación se ha realizado de manera éxitosa'),
        life: 3000,
      });
    }
    return true;
  };

  onHideModal = () => {
    this.setState({
      showModalJustification: {
        isVisible: false,
      },
    });
  };

  columnCountry = (rowData, detail) => (
    <>
        <span className="p-column-title">{detail.header}</span>
        {getValueLanguageObj(rowData.nombre)}
    </>
  )

  onRowReorder = async (newOrden) => {
    const { reOrderCountries } = this.props
    this.setState({loadingTable: true})
    const formatData = newOrden.value.map((item, index) => ({ id: item.id, orden: index + 1}))
    const response = await reOrderCountries(formatData)
    if (!response?.status) {
      this.setState({business: newOrden.value})
    }
    this.setState({loadingTable: false})
  }

  render() {
    const { t, history, validatePermissionAction } = this.props;
    const { loadingPage, business, loadingTable, showModalCountry, showModalEditCountry, showModalJustification } = this.state;
    if (loadingPage) return true

    const rightHeader = (
      <>
        <Button
          icon="pi pi-th-large"
          className="p-button-raised p-button-text p-button-plain"
          onClick={() => history.push('/dashboard')}
        />
        { validatePermissionAction(catalogPermissionsId.AGREGAR_PAIS) && (
          <Button
            label={t('Agregar País')}
            className="p-button-primary"
            onClick={() => this.openMoldalNewCountry() }
          />
        )}
      </>
    );

    return (
      <div className="p-grid">
        <div className="p-col-12">
          <Header title={t('Países')} rightComponent={rightHeader} />
          <div className="card">
            <div className="p-col-12 p-mt-2">
              <DataTable
                value={business}
                lazy
                loading={loadingTable}
                className="table-bussiness"
                onRowReorder={this.onRowReorder}
              >
                <Column
                  rowReorder
                  style={{width: '4em'}}
                  header={t('Orden')}
                  className="sm-invisible"
                />
                <Column
                  header={t('País')}
                  body={this.columnCountry}
                />
                <Column
                  header={t('Clave')}
                  body={this.templateClave}
                />
                { validatePermissionAction(catalogPermissionsId.EDITAR_PAISES) && (
                  <Column
                    header={t('Editar')}
                    body={this.templateEdit}
                    className="column-action p-text-center-lg"
                  />
                )}
                <Column
                  header={t('Visible')}
                  body={this.visibleCountry}
                  className="column-max p-text-center-lg"
                />
              </DataTable>
            </div>
          </div>
        </div>
        <Toast ref={(el) => (this.toast = el)} />
        { showModalCountry.isVisible && (
          <NewCountryModal
            onHidden={() => this.setState({showModalCountry: {isVisible: false}})}
            onContinueAction={showModalCountry.continueAction}
          />
        )}
        { showModalEditCountry.isVisible && (
          <EditCountryModal
            onHidden={() => this.setState({showModalEditCountry: {isVisible: false}})}
            data={showModalEditCountry.data}
            onContinueAction={showModalEditCountry.continueAction}
          />
        )}
        <JustificationModal
          display={showModalJustification.isVisible}
          title={showModalJustification.title}
          description={showModalJustification.description}
          label={showModalJustification.label}
          onHidden={() => this.onHideModal()}
          onContinueAction={showModalJustification.continueAction}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  countriesCurrentCatalog: state.catalogs.countriesCurrentCatalog,
});

const mapDispatchToProps = {
  getCoutries,
  newCountry,
  editCountry,
  updateVisibilityStatus,
  reOrderCountries,
  setCatalogCurrentCountries,
  validatePermissionAction,
  sendActionToBitacora,
  sendActionToBitacora
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(Countries);
